import React, {Component} from "react";
import Utils from "../../../../../utils/Utils";
import Icon from "../../../../../components/icon/Icon";
import Table from "../../../../../components/table/Table";
import SegnalazioniServices from "../../../../../services/SegnalazioniServices";
import {withTranslation} from "react-i18next";
import ContactTracingServices from "../../../../../services/ContactTracingServices";
import styles from "../../DatiSpecifici/DatiSpecifici.module.css";
import ContactTracingModale from "./ContactTracingModale";
import globals from "../../../../../config/appconfig";
import Modale from "../../../../../components/modale/Modale";
import _, { truncate } from "lodash";
import Spinner from "../../../../../components/spinner/Spinner";
import toasterConfig from "../../../../../config/toasterConfig";
import ToasterSingleton from "../../../../../singleton/ToasterSingleton";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli.json";
import stylesButton from "./ContactTracingModale.module.css";
import modalConfig from "../../../../../config/modalConfig";
import Button from "../../../../../components/button/Button";


class ContactTracing extends Component {

    state = {
        rows: [],
        totalElements: 0,
        cols: [],
        loading: false,
        order: "",
        sort: "",
        page: 0,
        totalPages: 0,
        size: 10,
        notifiche: [],
        visualizzaModale: false,
        modalBodyModifica: null,
        modalBodyInserisci: null,
        idContactTracing: null,
        nome: "",
        disabledButton: true,
        disabledButtonExcel: true,
        timestampUltimoInvioContattiMonkeypox: "",
        flagInserisci: false,
        dataMonkey:globals["data-inizio-monkeypox"]
        

    }

    constructor(props) {
        super(props);
        this.buildParams = this.buildParams.bind(this)
        this.getContactTracing = this.getContactTracing.bind(this)
        this.changePageTable = this.changePageTable.bind(this)
        this.changePaginationTable = this.changePaginationTable.bind(this)
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.salvaContatto = this.salvaContatto.bind(this);
        this.eliminaContatto = this.eliminaContatto.bind(this);
        this.downloadPdf=this.downloadPdf.bind(this);
        this.mailContatti=this.mailContatti.bind(this);
        this.downloadCsv=this.downloadCsv.bind(this);
        this.azzeraModale = this.azzeraModale.bind(this)
    }

    cols = [
        {key: "numero", name: "Tables.ContactTracing.numero", sortDirection: "none"},
        {key: "cognome", name: "Tables.ContactTracing.cognome", sortDirection: "none"},
        {key: "nome", name: "Tables.ContactTracing.nome", sortDirection: "none"},
        {key: "dataNascita", name: "Tables.ContactTracing.dataNascita", sortDirection: "none"},
        {key: "recapitoTelefonico", name: "Tables.ContactTracing.recapitoTelefonico", sortDirection: "none"},
        {key: "dataContatto", name: "Tables.ContactTracing.dataContatto", sortDirection: "none"},
        {key: "comuneDomicilio", name: "Tables.ContactTracing.domicilio", sortDirection: "none"},
        {key: "note", name: "Tables.ContactTracing.note", sortDirection: "none"},
        {
            tipo: "linkButton",
            key: "idContactTracing",
            typeButton: "White",
            nomeParametro: "Modifica contatto"
        },

        {
            tipo: "modale",
            key: "convertiSegnalazione",
            modalContent:{
                text:"Messages.CONVERTI_IN_SEGNALAZIONE",
                buttonText:"Converti in Segnalazione",
                conferma:"Conferma",
                annulla:"Torna alla segnalazione",
                buttonClass:"btn btn-link",
                title:"ATTENZIONE",
                classes:"btn btnBluOutline ",
                style: {
                    outline: "none !important",
                    border: "none",
                    background: "none",
                    fontSize: "16px",
                    color: "#1b7ea9",
                    textDecoration: "underline",
                }
            }

        }
    ]

    componentDidMount() {
        let contactTracingRequestParam = {
            size: this.state.size,
           
        }
        // let state = _.cloneDeep(this.state)
        const modalBodyInserisci =
            <ContactTracingModale salvaContatto={this.salvaContatto} idSegnalazione={this.props.idSegnalazione}/>
        const timestampUltimoInvioContattiMonkeypox = this.props.segnalazioneCopia.timestampUltimoInvioContattiMonkeypox
        this.setState({modalBodyInserisci: modalBodyInserisci, timestampUltimoInvioContattiMonkeypox: timestampUltimoInvioContattiMonkeypox}, () => this.getContactTracing(contactTracingRequestParam))
        

    }

    getContactTracing(contactTracingRequestParam) {
        this.setState({loading: true})
        ContactTracingServices.getContactTracing(contactTracingRequestParam, this.props.idSegnalazione).then((data) => {
            let dataInvioEmail=this.state.timestampUltimoInvioContattiMonkeypox;
            let datSeg= new Date(this.props.segnalazioneCopia.timestampCompilazione);
          
            console.log(process.env)
            let res = ContactTracingServices.mapGetontactTracing(data, dataInvioEmail);
            
            let newState = {
                rows: res,
                loading: false,
                totalPages: data.data.totalPages,
                totalElements: data.data.totalElements,
                modalBodyInserisci: <ContactTracingModale salvaContatto={this.salvaContatto}
                                                          idSegnalazione={this.props.idSegnalazione}/>
            }

            if (contactTracingRequestParam.size && contactTracingRequestParam.size !== this.state.size) {
                newState["size"] = contactTracingRequestParam.size
            }

            if ((contactTracingRequestParam.page || contactTracingRequestParam.page === 0) && contactTracingRequestParam.page !== this.state.page) {
                newState["page"] = contactTracingRequestParam.page
            }

            if (contactTracingRequestParam.order && contactTracingRequestParam.order !== this.state.order) {
                newState["order"] = contactTracingRequestParam.order
            }

            if (contactTracingRequestParam.sort && contactTracingRequestParam.sort !== this.state.sort) {
                newState["sort"] = contactTracingRequestParam.sort
            }

            let datX=new Date(this.state.dataMonkey); 
            res.forEach((el,index) =>{
                let pro=el.provincia;
                if(datSeg.getTime() > datX.getTime() && pro != null && pro !== "025" && pro !== "028" && pro !== "029"
                    && pro !== "026" && pro !== "027" && pro !== "023" && pro !== "024"){
                        newState["disabledButton"] = false
                    }
                if(datSeg.getTime() > datX.getTime()) {
                    newState["disabledButtonExcel"] = false
                }
                
            })

            this.setState(newState);
           

        }).catch(() => {
            let newState = {rows: [], totalElements: 0, loading: false, page: 0};

            newState["size"] = this.state.size

            if ((contactTracingRequestParam.page || contactTracingRequestParam.page === 0) && contactTracingRequestParam.page !== this.state.page) {
                newState["page"] = contactTracingRequestParam.page
            }

            this.setState(newState);
        })
    }

    handleLinkClick(row) {
        let state = _.cloneDeep(this.state)
        ContactTracingServices.getContatto(row.idContactTracing).then((data) => {
            let res = data.data;
            res["dataNascita"] = res.dataNascita ? Utils.transformTimeStampForFrontend(res.dataNascita) : null;
            res["dataContatto"] = res.dataContatto ? Utils.transformTimeStampForFrontend(res.dataContatto) : null;
            res["dataSintomi"] = res.dataSintomi ? Utils.transformTimeStampForFrontend(res.dataSintomi) : null;
            state.modalBodyModifica = <ContactTracingModale contatto={res} salvaContatto={this.salvaContatto}
                                                            eliminaContatto={this.eliminaContatto}
                                                            idSegnalazione={this.props.idSegnalazione}/>
            state.flagInserisci = false
            this.setState(state, () => document.getElementById('modalButton_modificaContatto').click())
        }).catch(() => {
        })
    }

    changePageTable(sort, direction, page, size) {

        let params = this.buildParams(sort, direction, page, size);

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }


        this.getContactTracing(params)


    }

    changePaginationTable(sort, direction, page, size) {
        let params = this.buildParams(sort, direction, page, size);

        if (size != null)
            params.size = size


        this.getContactTracing(params)

    }

    buildParams(sort, direction, page, size) {
        let params = {}

        params.sort = sort

        params.page = page

        params.order = direction

        params.size = size

        return Utils.removeEmptyValueFromObject(params)
    }

    salvaContatto(jsonInsert, idSegnalazione) {

        jsonInsert.dataNascita = jsonInsert.dataNascita ? Utils.transformDateForBackend(jsonInsert.dataNascita) : null
        jsonInsert.dataContatto = jsonInsert.dataContatto ? Utils.transformDateForBackend(jsonInsert.dataContatto) : null
        jsonInsert.dataSintomi = jsonInsert.dataSintomi ? Utils.transformDateForBackend(jsonInsert.dataSintomi) : null
        
        let contatto = Utils.removeEmptyValueFromObject(jsonInsert)
        ContactTracingServices.postPutContactTracing(contatto, idSegnalazione).then((data) => {
            let contactTracingRequestParam = {}
            if (jsonInsert.idContactTracing) {
                contactTracingRequestParam = {
                    size: this.state.size,
                    order: this.state.order,
                    sort: this.state.sort,
                    page: this.state.page,
                }
            } else {
                contactTracingRequestParam = {
                    size: 10,
                    order: this.state.order,
                    sort: this.state.sort,
                    page: 0,
                }
            }
            this.getContactTracing(contactTracingRequestParam)
 
        }).catch(() => {
        });
    }

    eliminaContatto(idContactTracing) {
        ContactTracingServices.deleteContactTracing(idContactTracing).then((data) => {
            let contactTracingRequestParam = {
                size: 10,
                order: this.state.order,
                sort: this.state.sort,
                page: 0,
            }
            this.getContactTracing(contactTracingRequestParam)

        }).catch(() => {
        });
    }

    azzeraModale () {
        let state = _.cloneDeep(this.state)
        state.flagInserisci = true
        state.modalBodyModifica = <ContactTracingModale salvaContatto={this.salvaContatto}
                                                        idContactTracing={null}
                                                        idSegnalazione={this.props.idSegnalazione}/>
        this.setState(state, () => document.getElementById('modalButton_modificaContatto').click())
    }

    render() {
        console.log("rows " + this.state.rows)
        const {t} = this.props;
        return (
            <>
                {this.state.loading ? (<div><Spinner/></div>) : (<div/>)}
                <div style={{marginTop: "1rem"}}>
                    <h6>{t("Tables.ContactTracing.titolo")}</h6>
                    <hr className={styles.hr}/>
                    <Modale classes="btnWhite" id={"modificaContatto"} typeModal="modalConsenso"
                            title={this.state.flagInserisci? t("Tables.ContactTracing.inserisci") : t("Tables.ContactTracing.modifica")}
                            style={{height: "3rem", marginTop: "1rem", display: "none"}}
                            body={this.state.modalBodyModifica ?? null}
                    />
                    <div className={"row"}>
                        <div className={"col-5"}/>
                        <div className={"col-2"}>
                            <Button
                                id={"inserisciContatto"}
                                className={["btnBluOutline", stylesButton.buttonOk].join(" ").concat(" btn")}
                                data-dismiss="modal"
                                style={{height: "3rem", marginTop: "1rem"}}
                                type="button"
                                onClick={this.azzeraModale}
                                disabled={!this.props.idSegnalazione}
                                text={t("Tables.ContactTracing.inserisci")}

                            />
                        </div>
                    </div>

                        <div className={"container"}>
                            {SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Regionale.descrizione ?
                            <div className="d-flex flex-row-reverse" style={{marginBottom:"-65px"}}>
                            <Modale title={"Invia mail"}
                                    className={styles.testo}
                                    id="modaleEmail"
                                    name="modaleEmail"
                                    modalText= {"Si vuole procedere con l'invio della mail? "}
                                    text={<Icon style={this.state.disabledButton? {paddingRight: "10px", fill: "#a9a9a9"} : {paddingRight: "10px", fill: "#1b7ea9"}} id="it-mail"/>}
                                    typeModal="modalConsenso"
                                    textButtonOk={"Prosegui"}
                                    textButtonKo={"Annulla"}
                                    classes="btn mt-2 btnWhite mb-1"
                                    style={{
                                        padding: "5px",
                                        border: "none",
                                        background: "none",
                                        float: "right",
                                        width: "30px"
                                    }}
                                    confirmFun={this.mailContatti}
                                    disabled={this.state.disabledButton}/>

                            <Modale title={"Scarica in formato Pdf"}
                                    className={styles.testo}
                                    id="modaleDownload"
                                    name="modaleDownload"
                                    modalText= {"Si vuole procedere con il download dei contatti? "}
                                    text={<Icon style={this.state.disabledButton? {paddingRight: "10px", fill: "#a9a9a9"} : {paddingRight: "10px", fill: "#ff0000"}} id="it-file"/>}
                                    typeModal="modalConsenso"
                                    textButtonOk={"Prosegui"}
                                    textButtonKo={"Annulla"}
                                    classes="btn mt-2 btnWhite mb-1 "
                                    style={{
                                        padding: "5px",
                                        border: "none",
                                        background: "none",
                                        float: "right",
                                        width: "30px"
                                    }}
                                    confirmFun={this.downloadPdf}
                                    disabled={this.state.disabledButton}/>

                                <Modale title={"Scarica in formato csv"}
                                    className={styles.testo}
                                    id="modaleCsvDownload"
                                    name="modaleCsvDownload"
                                    modalText= {"Si vuole procedere con il download del csv dei contatti? "}
                                    text={<Icon style={this.state.disabledButtonExcel? {paddingRight: "10px", fill: "#a9a9a9"} : {paddingRight: "10px", fill: "#3cb371"}} id="it-file"/>}
                                    typeModal="modalConsenso"
                                    textButtonOk={"Prosegui"}
                                    textButtonKo={"Annulla"}
                                    classes="btn mt-2 btnWhite mb-1 "
                                    style={{
                                        padding: "5px",
                                        border: "none",
                                        background: "none",
                                        float: "right",
                                        width: "30px"
                                    }}
                                    confirmFun={this.downloadCsv}
                                    disabled={this.state.disabledButtonExcel}/>
                            </div> : <div className="d-flex flex-row-reverse" style={{marginBottom:"-65px"}}>
                                    <Modale title={"Scarica in formato csv"}
                                            className={styles.testo}
                                            id="modaleCsvDownload"
                                            name="modaleCsvDownload"
                                            modalText= {"Si vuole procedere con il download del csv dei contatti? "}
                                            text={<Icon style={this.state.disabledButtonExcel? {paddingRight: "10px", fill: "#a9a9a9"} : {paddingRight: "10px", fill: "#3cb371"}} id="it-file"/>}
                                            typeModal="modalConsenso"
                                            textButtonOk={"Prosegui"}
                                            textButtonKo={"Annulla"}
                                            classes="btn mt-2 btnWhite mb-1 "
                                            style={{
                                                padding: "5px",
                                                border: "none",
                                                background: "none",
                                                float: "right",
                                                width: "30px"
                                            }}
                                            confirmFun={this.downloadCsv}
                                            disabled={this.state.disabledButtonExcel}/>

                                </div>}
                            <Table cols={this.cols} rows={this.state.rows}
                                   emptyMsg={t("Tables.ContactTracing.noContactTracing")}
                                   lengthEditable={true}
                                   totalElements={this.state.totalElements}
                                   bigTable={false}
                                   totalPages={this.state.totalPages}
                                   page={this.state.page}
                                   changePage={this.changePageTable}
                                   changePagination={this.changePaginationTable}
                                   onButtonSelect={this.handleLinkClick}
                                   onModalConferma={this.props.convertiSegnalazione}
                                   tooltipTable={true}
                                   reportStatistici={true}

                            />
                        </div>
                </div>

            </>

        );

    }

    downloadPdf() {

        SegnalazioniServices.getContattiMonkypoxPDF(this.props.idSegnalazione).then(data => {
            Utils.downloadReport(data.data.stream, data.data.descrizione, data.data.formato)
            
        })
    }

    downloadCsv() {

        SegnalazioniServices.getContattiMonkypoxCSV(this.props.idSegnalazione).then(data => {
            Utils.downloadReport(data.data.stream, data.data.descrizione, data.data.formato)
            
        })
    }

    mailContatti() {

        SegnalazioniServices.invioMailMonkeypox(this.props.idSegnalazione).then(data => {

            let contactTracingRequestParam = {
                size: this.state.size

            }

            let dataAggiornata = new Date(Date.now()).toISOString();
            this.setState({timestampUltimoInvioContattiMonkeypox: dataAggiornata})
            this.getContactTracing(contactTracingRequestParam)
            this.props.setStatePadre({timestampUltimoInvioContattiMonkeypox: dataAggiornata})
            this.aggiungiToaster(toasterConfig.types.successo, "L'email è stata inviata correttamente");
        })
    }

    aggiungiToaster(type, text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: type,
            text: text,
            timestamp: Date.now()
        })
    }

}

export default withTranslation('common')(ContactTracing);